/** Registro de tokens de color — debe coincidir con backend/theme_tokens.py */

import {
  NAV_SECTIONS, INFORME_SECTIONS, KPI_SECTIONS, flatSectionDefaults,
} from "./sectionTheme";

function sectionTokenEntries(sections, prefix = "") {
  return Object.entries(sections).flatMap(([key, { label }]) => {
    const full = prefix ? `${prefix}${key}` : key;
    return [
      { key: `sec-${full}-from`, label: `${label} — inicio` },
      { key: `sec-${full}-to`, label: `${label} — fin` },
    ];
  });
}

export const TOKEN_GROUPS = [
  {
    id: "base",
    label: "Base",
    tokens: [
      { key: "background", label: "Fondo principal" },
      { key: "foreground", label: "Texto principal" },
      { key: "border", label: "Bordes" },
      { key: "input", label: "Campos de entrada" },
      { key: "ring", label: "Anillo de foco" },
    ],
  },
  {
    id: "surfaces",
    label: "Superficies",
    tokens: [
      { key: "card", label: "Tarjetas — fondo" },
      { key: "card-foreground", label: "Tarjetas — texto" },
      { key: "popover", label: "Popovers — fondo" },
      { key: "popover-foreground", label: "Popovers — texto" },
      { key: "muted", label: "Fondo atenuado" },
      { key: "muted-foreground", label: "Texto atenuado" },
      { key: "surface-raised", label: "Superficie elevada (solo oscuro)" },
    ],
  },
  {
    id: "actions",
    label: "Acciones",
    tokens: [
      { key: "primary", label: "Primario — fondo" },
      { key: "primary-foreground", label: "Primario — texto" },
      { key: "secondary", label: "Secundario — fondo" },
      { key: "secondary-foreground", label: "Secundario — texto" },
      { key: "accent", label: "Acento — fondo" },
      { key: "accent-foreground", label: "Acento — texto" },
      { key: "destructive", label: "Destructivo — fondo" },
      { key: "destructive-foreground", label: "Destructivo — texto" },
    ],
  },
  {
    id: "brand",
    label: "Marca corporativa",
    tokens: [
      { key: "brand", label: "Color de marca" },
      { key: "brand-foreground", label: "Texto sobre marca" },
      { key: "brand-muted", label: "Fondo suave de marca" },
      { key: "brand-muted-foreground", label: "Texto sobre fondo suave" },
      { key: "brand-border", label: "Borde de marca" },
    ],
  },
  {
    id: "layout",
    label: "Cabeceras y navegación",
    tokens: [
      { key: "header-from", label: "Gradiente cabecera — inicio" },
      { key: "header-via", label: "Gradiente cabecera — centro" },
      { key: "header-to", label: "Gradiente cabecera — fin" },
      { key: "sidebar-from", label: "Gradiente sidebar — inicio" },
      { key: "sidebar-to", label: "Gradiente sidebar — fin" },
    ],
  },
  {
    id: "cta",
    label: "Botones de acción (CTA rojo)",
    tokens: [
      { key: "cta-from", label: "Botón publicar — inicio" },
      { key: "cta-to", label: "Botón publicar — fin" },
      { key: "cta-foreground", label: "Botón publicar — texto" },
    ],
  },
  {
    id: "org_header",
    label: "Encabezado Organización",
    tokens: [
      { key: "org-header-from", label: "Organización — inicio" },
      { key: "org-header-via", label: "Organización — centro" },
      { key: "org-header-to", label: "Organización — fin" },
      { key: "org-header-foreground", label: "Organización — texto" },
    ],
  },
  {
    id: "fichar",
    label: "Widget Fichar (trabajador)",
    tokens: [
      { key: "fichar-btn-from", label: "Botón Entrar — inicio" },
      { key: "fichar-btn-to", label: "Botón Entrar — fin" },
      { key: "fichar-btn-ring", label: "Botón Entrar — anillo" },
      { key: "fichar-surface", label: "Panel reloj — fondo" },
      { key: "fichar-surface-border", label: "Panel reloj — borde" },
      { key: "fichar-label", label: "Panel reloj — etiqueta fecha" },
    ],
  },
  {
    id: "worker_zonas",
    label: "Zonas (vista trabajador)",
    tokens: [
      { key: "worker-zonas-bg-from", label: "Cabecera — fondo inicio" },
      { key: "worker-zonas-bg-to", label: "Cabecera — fondo fin" },
      { key: "worker-zonas-border", label: "Cabecera — borde" },
      { key: "worker-zonas-accent", label: "Botón acento — fondo" },
      { key: "worker-zonas-accent-fg", label: "Botón acento — texto" },
      { key: "worker-zonas-accent-hover", label: "Botón acento — hover" },
      { key: "worker-zonas-subtitle", label: "Subtítulo" },
    ],
  },
  {
    id: "nav_sections",
    label: "Menú lateral — secciones",
    tokens: sectionTokenEntries(NAV_SECTIONS),
    collapsible: true,
  },
  {
    id: "informe_sections",
    label: "Listados e informes — tipos",
    tokens: sectionTokenEntries(INFORME_SECTIONS, "informe-"),
    collapsible: true,
  },
  {
    id: "kpi_sections",
    label: "Tarjetas KPI (panel e informes)",
    tokens: sectionTokenEntries(KPI_SECTIONS, "kpi-"),
    collapsible: true,
  },
  {
    id: "charts",
    label: "Gráficos",
    tokens: [
      { key: "chart-1", label: "Gráfico 1" },
      { key: "chart-2", label: "Gráfico 2" },
      { key: "chart-3", label: "Gráfico 3" },
      { key: "chart-4", label: "Gráfico 4" },
      { key: "chart-5", label: "Gráfico 5" },
    ],
  },
  {
    id: "misc",
    label: "Otros",
    tokens: [
      { key: "selection-bg", label: "Selección de texto — fondo" },
      { key: "selection-fg", label: "Selección de texto — color" },
    ],
  },
];

export const ALL_TOKEN_KEYS = TOKEN_GROUPS.flatMap((g) => g.tokens.map((t) => t.key));

export function hslToCss(hsl) {
  if (!hsl) return "transparent";
  return `hsl(${hsl})`;
}

export function parseHsl(hsl) {
  if (!hsl || typeof hsl !== "string") return null;
  const m = hsl.trim().match(/^(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)%\s+(\d+(?:\.\d+)?)%$/);
  if (!m) return null;
  return { h: Number(m[1]), s: Number(m[2]), l: Number(m[3]) };
}

export function hslToHex(hsl) {
  const p = parseHsl(hsl);
  if (!p) return "#6366f1";
  const { h, s, l } = p;
  const a = (s / 100) * Math.min(l / 100, 1 - l / 100);
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l / 100 - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, "0");
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

export function hexToHsl(hex) {
  const raw = hex.replace("#", "");
  if (raw.length !== 6) return "0 0% 50%";
  const r = parseInt(raw.slice(0, 2), 16) / 255;
  const g = parseInt(raw.slice(2, 4), 16) / 255;
  const b = parseInt(raw.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) * 60; break;
      case g: h = ((b - r) / d + 2) * 60; break;
      default: h = ((r - g) / d + 4) * 60; break;
    }
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function applyEmpresaTheme(colores, mode) {
  const root = document.documentElement;
  const sectionDefaults = flatSectionDefaults();
  const vars = { ...sectionDefaults, ...(colores?.[mode] || {}) };
  ALL_TOKEN_KEYS.forEach((key) => {
    if (vars[key]) root.style.setProperty(`--${key}`, vars[key]);
  });
}

export function clearEmpresaTheme(colores) {
  const root = document.documentElement;
  const sectionDefaults = flatSectionDefaults();
  const modes = colores ? ["light", "dark"] : ["light", "dark"];
  modes.forEach((mode) => {
    const vars = { ...sectionDefaults, ...(colores?.[mode] || {}) };
    ALL_TOKEN_KEYS.forEach((key) => {
      if (vars[key]) root.style.removeProperty(`--${key}`);
    });
  });
}
